import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export default function Footer() {
  const [schoolName, setSchoolName] = useState("Loading...");

  useEffect(() => {
    const fetchSchoolName = async (user) => {
      try {
        // Fetch user's document
        const userSnap = await getDoc(doc(db, "users", user.uid));
        if (!userSnap.exists()) return;

        const userData = userSnap.data();
        const schoolId = userData.schoolId;

        if (schoolId) {
          // Fetch school document
          const schoolSnap = await getDoc(doc(db, "schools", schoolId));
          if (schoolSnap.exists()) {
            setSchoolName(schoolSnap.data().schoolName || "My School");
          } else {
            setSchoolName("School Not Found");
          }
        } else {
          setSchoolName("No School Assigned");
        }
      } catch (error) {
        console.error("Error fetching school:", error);
        setSchoolName("Error Loading School");
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) fetchSchoolName(user);
      else setSchoolName("Not Logged In");
    });

    return () => unsubscribe();
  }, []);

  return (
    <div>
      <footer
        className="main-footer"
        style={{
          background: "linear-gradient(90deg,#0f172a,#1e293b)",
          color: "#e2e8f0",
          padding: "12px 20px",
          fontSize: 14,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          marginTop: 20,
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)"
        }}
      >
        {/* LEFT */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <i className="fas fa-school" style={{ color: "#14b8a6", fontSize: 18 }}></i>
          <span>
            <strong>{schoolName}</strong> © 2026-2027
          </span>
        </div>

        {/* RIGHT */}
        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
          <span style={{ color: "#94a3b8" }}>
            Version <b>3.1.0</b>
          </span>
          <span style={{ color: "#64748b" }}>
            All rights reserved. Developed by <a href='https://blueviperstechnology.com' target='_blank' style={{ color: "white" }}>Bluevipers Technology <i className='fa fa-heart'></i></a>.
          </span>
        </div>
      </footer>
    </div>
  );
}